import { render, staticRenderFns } from "./pkgRiskItemReview.vue?vue&type=template&id=233dcfc6&"
import script from "./pkgRiskItemReview.vue?vue&type=script&lang=js&"
export * from "./pkgRiskItemReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports